import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from '@modules/main/main.component';
import { BlankComponent } from '@pages/blank/blank.component';
import { LoginComponent } from '@modules/login/login.component';
import { ProfileComponent } from '@pages/profile/profile.component';
import { RegisterComponent } from '@modules/register/register.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { AuthGuard } from '@guards/auth.guard';
import { NonAuthGuard } from '@guards/non-auth.guard';
import { ForgotPasswordComponent } from '@modules/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from '@modules/recover-password/recover-password.component';
import { SubMenuComponent } from '@pages/main-menu/sub-menu/sub-menu.component';
import { WebsiteComponent } from '@pages/website/website.component';
import { DetailViewComponent } from '@pages/detail-view/detail-view.component';
import { InvoiceComponent } from "@pages/invoice/invoice.component";
import { ProductViewComponent } from '@pages/admin/product-view/product-view.component';
import { EnquiryComponent } from "@pages/enquiry/enquiry.component";
import { BillComponent } from "@pages/bill/bill.component";
import { ShopBillListTableComponent } from '@pages/admin/shop-bill-list-table/shop-bill-list-table.component';
import { CreateBoschProductComponent } from '@pages/admin/create-bosch-product/create-bosch-product.component';
import { UserProfileComponent } from '@pages/admin/user-profile/user-profile.component';

const routes: Routes = [
  {
    path: 'main',
    component: MainComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'profile',
        component: ProfileComponent
      },
      {
        path: 'blank',
        component: BlankComponent
      },
      {
        path: 'sub-menu-1',
        component: SubMenuComponent
      },
      {
        path: 'sub-menu-2',
        component: BlankComponent
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'invoice',
        component: InvoiceComponent
      },
      {
        path: 'product-view',
        component: ProductViewComponent
      },
      {
        path: 'enquiry',
        component: EnquiryComponent
      },
      {
        path: 'shop-bill-list',
        component: ShopBillListTableComponent
      },
      {
        path: 'create',
        component: CreateBoschProductComponent
      },
      {
        path: 'user-profile',
        component: UserProfileComponent
      },
    ]
  },
  {
    path: 'login',
    component: LoginComponent,
    // canActivate: [NonAuthGuard]
  },
  {
    path: 'register',
    component: RegisterComponent,
    // canActivate: [NonAuthGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    // canActivate: [NonAuthGuard]
  },
  {
    path: 'recover-password',
    component: RecoverPasswordComponent,
    // canActivate: [NonAuthGuard]
  },
  {
    path: '',
    component: WebsiteComponent,
    // canActivate: [NonAuthGuard]
  },
  {
    path: 'detail-view',
    component: DetailViewComponent,
  },
  {
    path: 'bill',
    component: BillComponent
  },

  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
